import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Industries from '../components/Industries/Industries';
import Faq from '../components/Main/Faq';
import Footer from '../components/Main/Footer';
import Video from '../components/Main/Video';
import Files from '../components/Main/FilesForPayment';
import { BACKEND_URL } from '../consts';


const IndustriesPage = () => {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // const BASE_URL = "http://v2691254.hosted-by-vdsina.ru"

    useEffect(() => {
        const fetchData = async () => {
            try {
                try {
                    const response = await axios.get(`${BACKEND_URL}/api/v1/block/industries/${id}`);
                    const jsonData = response.data; // Данные уже в формате JSON
                    setData(jsonData); // Установим данные из ответа
                } catch (error) {
                    console.error("Ошибка при загрузке данных:", error);
                    // Здесь можно также установить состояние ошибки, если это необходимо
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []); 

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div>
            {
                data.map((block) => {
                    switch (block.type){
                        case 'invoices_block':
                            return <Industries data={data[0].payload} />;
                        case 'children_block':
                            return <Industries data={data[0].payload} />;
                        case 'clothes_block':
                            return <Industries data={data[0].payload} />;
                        case 'china_repayment_block':
                            return <Industries data={data[0].payload} />;
                        case 'technic_block':
                            return <Industries data={data[0].payload} />;
                        case 'sport_block':
                            return <Industries data={data[0].payload} />;
                        case 'special_equipment_block':
                            return <Industries data={data[0].payload} />;
                        case 'korean_repayment_block':
                            return <Industries data={data[0].payload} />;
                        case 'video_block':
                            return <><Video key={block.id} data={block.payload} /><Files/></>;
                        case 'faq_block':
                            return <Faq key={block.id} data={block.payload} />;
                        case 'footer_block':
                            return <Footer key={block.id} data={block.payload} />;
                    }
                })
            }
            
        </div>
    );
};

export default IndustriesPage;
